import { render, staticRenderFns } from "./DepartmentSelectedPanel.vue?vue&type=template&id=fd1067a2"
import script from "./DepartmentSelectedPanel.vue?vue&type=script&lang=js"
export * from "./DepartmentSelectedPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports